import { getPoints } from './helpers/star.js'
import star from './helpers/star.js'
import Symbol2d from '../2d.js'

const offset = .1 // Controls the depth of the rays

const rays = 20

export default class Seal extends Symbol2d {

  path (dimensions) {
    const radius = dimensions.width / 2 // aspect ratio of 1:1, so width and height are the same
    return star(rays, dimensions.center, radius, radius - (radius * offset))
  }

  textContainer (dimensions) {
    const radius = dimensions.width / 2
    const points = getPoints(rays, dimensions.center, radius, radius - (radius * offset))

    const width = (points[2][0] - dimensions.center[0]) * 2

    return {
      center: dimensions.center,
      width,
      height: width
    }
  }

}
